export default __webpack_public_path__ + "static/media/img2.92ca31d5.PNG";